var WithoutLoginModule = /** @class */ (function () {
    function WithoutLoginModule() {
    }
    return WithoutLoginModule;
}());
export { WithoutLoginModule };
